export default __webpack_public_path__ + "src/assets/Ledger_Mobile.95490407ce48428233be74ac3329cd9d.svg";